import {
  GET_DOCUMENTS_LIST,
  GET_DOCUMENTS_LIST_SUCCESS,
  GET_DOCUMENTS_LIST_FAILED,
  ADD_DOCUMENT,
  ADD_DOCUMENTS_SUCCESS,
  ADD_DOCUMENT_FAILED,
  EDIT_DOCUMENT,
  EDIT_DOCUMENTS_SUCCESS,
  EDIT_DOCUMENT_FAILED,
  CHANGE_THE_DOC_STATUS,
  CHANGE_THE_DOC_STATUS_SUCCESS,
  CHANGE_THE_DOC_STATUS_FAILED,
  ADD_THE_VERIFICATION_DOCS,
  ADD_THE_VERIFICATION_DOCS_SUCCESS,
  ADD_THE_VERIFICATION_DOCS_FAILED,
  GET_VERIFICATION_DOC_DETAILS,
  GET_VERIFICATION_DOC_DETAILS_SUCCESS,
  GET_VERIFICATION_DOC_DETAILS_FAILED,
  SUBMIT_DOC_STATUS,
  SUBMIT_DOC_STATUS_SUCCESS,
  SUBMIT_DOC_STATUS_FAILED,
} from "./actionTypes";

const initialState = {
  documentsLoading: null,
  documentsList: null,
  addDocSuccess: null,
  addDocFailed: null,
  editDocSuccess: null,
  editDocFailed: null,
  addVerificationDocs:null,
  addVerificationDocsFailed:null,
  candidateVerDocList:null,
  candidateVerDocListFailed:null,
  submitStatusSuccess:null,
  submitStatusFailed:null,
};

const documentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DOCUMENTS_LIST:
      state = {
        ...state,
        documentsLoading: true,
        documentsList: null,
        addDocSuccess: null,
        editDocSuccess: null,
        addDocFailed: null,
        changeStatus: null,
        changeStatusFailed: null,
      };
      break;
    case GET_DOCUMENTS_LIST_SUCCESS:
      state = {
        ...state,
        documentsLoading: false,
        documentsList: action.payload,
      };
      break;
    case GET_DOCUMENTS_LIST_FAILED:
      state = {
        ...state,
        documentsLoading: false,
        documentsList: null,
      };
      break;
    case ADD_DOCUMENT:
      state = {
        ...state,
        documentsLoading: true,
        addDocFailed: null,
        addDocSuccess: null,
      };
      break;
    case ADD_DOCUMENTS_SUCCESS:
      state = {
        ...state,
        documentsLoading: false,
        addDocFailed: null,
        addDocSuccess: action.payload,
      };
      break;
    case ADD_DOCUMENT_FAILED:
      state = {
        ...state,
        documentsLoading: false,
        addDocFailed: action.payload,
        addDocSuccess: null,
      };
      break;
    case EDIT_DOCUMENT:
      state = {
        ...state,
        documentsLoading: true,
        editDocSuccess: null,
        editDocFailed: null,
      };
      break;
    case EDIT_DOCUMENTS_SUCCESS:
      state = {
        ...state,
        documentsLoading: false,
        editDocSuccess: action.payload,
        editDocFailed: null,
      };
      break;
    case EDIT_DOCUMENT_FAILED:
      state = {
        ...state,
        documentsLoading: false,
        editDocSuccess: null,
        editDocFailed: action.payload,
      };
      break;
    case CHANGE_THE_DOC_STATUS:
      state = {
        ...state,
        documentsLoading: true,
        changeStatus: null,
        changeStatusFailed: null,
      };
      break;
    case CHANGE_THE_DOC_STATUS_SUCCESS:
      state = {
        ...state,
        documentsLoading: false,
        changeStatus: action.payload,
        changeStatusFailed: null,
      };
      break;
    case CHANGE_THE_DOC_STATUS_FAILED:
      state = {
        ...state,
        documentsLoading: false,
        changeStatus: null,
        changeStatusFailed: action.payload,
      };
      break;
      case ADD_THE_VERIFICATION_DOCS:
      state = {
        ...state,
        documentsLoading: true,
        addVerificationDocs:null,
  addVerificationDocsFailed:null
      };
      break;
      case ADD_THE_VERIFICATION_DOCS_SUCCESS:
      state = {
        ...state,
        documentsLoading: false,
        addVerificationDocs:action.payload,
  addVerificationDocsFailed:null
      };
      break;
      case ADD_THE_VERIFICATION_DOCS_FAILED:
      state = {
        ...state,
        documentsLoading: false,
        addVerificationDocs:null,
  addVerificationDocsFailed:action.payload
      };
      break;
      case GET_VERIFICATION_DOC_DETAILS:
        state = {
          ...state,
          documentsLoading: true,
          candidateVerDocList:null,
  candidateVerDocListFailed:null
          
        };
        break;
        case GET_VERIFICATION_DOC_DETAILS_SUCCESS:
        state = {
          ...state,
          documentsLoading: false,
          candidateVerDocList:action.payload,
          candidateVerDocListFailed:null
          
        };
        break;
        case GET_VERIFICATION_DOC_DETAILS_FAILED:
        state = {
          ...state,
          documentsLoading: false,
          candidateVerDocList:null,
          candidateVerDocListFailed:action.payload
          
        };
        break;
        case SUBMIT_DOC_STATUS:
        state = {
          ...state,
          documentsLoading: true,
          submitStatusSuccess:null,
          submitStatusFailed:null,
          
        };
        break;
        case SUBMIT_DOC_STATUS_SUCCESS:
        state = {
          ...state,
          documentsLoading: false,
          submitStatusSuccess:action.payload,
          submitStatusFailed:null,
          
        };
        break;
        case SUBMIT_DOC_STATUS_FAILED:
        state = {
          ...state,
          documentsLoading: false,
          submitStatusSuccess:null,
  submitStatusFailed:action.payload,
        };
        break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default documentsReducer;
